module.exports = __webpack_public_path__ + "static/media/BLUSH_6252.375a8b3b.jpg";